module.exports = __webpack_public_path__ + "summernote.82fa597f29de41cd41a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.ttf
// module id = 1027
// module chunks = 3